import React from 'react';

// CTA that opens the Google Calendar booking page for ICRS 2026.
const BookDemoButton = () => (
  <a
    href="https://calendar.app.google/NkeqVd3dUCQpfv8Z9"
    target="_blank"
    rel="noopener noreferrer"
    className="icrs-cta-btn"
  >
    Reserve Time with Rentid at ICRS 2026
  </a>
);

export default BookDemoButton;
